// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import {
  version as currentVersion
} from '../../../../../package.json';

/**
 * Returns an error jsx element
 *
 * @returns react element
 */
export default function landing(): JSX.Element {
  return (
    <div id="content" className="container login-layer">
      <div style={{ textAlign: 'center' }}>
        <header style={{ marginTop: '150px' }}>
          <div id="login-logo">
            <img src="assets/img/logos/logo_negativo.png" alt="EntropySmart" />
            <br />
            <b>EntropySmart-IOT</b> - {currentVersion}
          </div>
        </header>
      </div>
    </div>
  );
}
